import { render } from "./ConfirmEmail.vue?vue&type=template&id=52befd14"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__